import {
  AdminAxios,
  AdverAxios,
  AxiosFile,
  AxiosImage, AxiosImageAdver
} from "../../common/Axios";
import {responseFormatMessage} from "../../common/StringUtils";
const isInit = false;

const ACTION_URL = '/user';
const USER_MANAGE_URL ='/adver/user'
const CAMPAIGN_MANAGE_URL ='/adver/campaign'
const SLASH = '/';

const USER_LIST = USER_MANAGE_URL+'/list'
const USER_INFO = USER_MANAGE_URL+'/uuid'
const MY_PAGE_INFO =ACTION_URL+'/uuid'
const USER_KEYWORD_SEARCH = USER_MANAGE_URL + '/find/by-adver'
const USER_CAMPAIGN_KEYWORD_SEARCH = ACTION_URL + '/find/{id}/by-campaign'
const CAMPAIGN_KEYWORD_SEARCH = USER_MANAGE_URL + '/find/{id}/by-campaign'
const INVENTORY_KEYWORD_SEARCH = CAMPAIGN_MANAGE_URL + '/find/{id}/by-inventory'
const BY_USER_INFO = ACTION_URL+'/username'

const TERMS_INFO = '/policy/latest-terms'
const SIGNUP_URL = ACTION_URL + '/sign-up'
const VALID_USERID = ACTION_URL + '/verify/username'
const FIND_USERID = ACTION_URL + '/find/my-id'
const CHANGE_PASSWORD = ACTION_URL + '/find/my-password'
const UPLOAD_URL = ACTION_URL + '/image' + SLASH;

/**
 * 사용자 리스트 가져오기 api
 * @param userParams
 * @returns {Promise<null>}
 */
export async function selUserList(userParams) {
  let returnVal = null;
  await AdminAxios('POST', USER_LIST, userParams)
    .then((response) => {
      const {data, statusCode} = response;
      if (statusCode === 200) {
        returnVal = data
      } else {
        returnVal = null
      }
    }).catch((e) => returnVal = false)
  return returnVal;
}

/**
 * 사용자 단건 조회 api
 * @param userId
 * @returns {Promise<null>}
 */
export async function selUserInfo(id) {
  let returnVal = null;
  await AdminAxios('GET', USER_INFO +SLASH + id)
    .then((response) => {
      const {data, statusCode} = response;
      if (statusCode === 200) {
        returnVal = data
      } else {
        returnVal = null
      }
    }).catch((e) => returnVal = false)
  return returnVal;
};

/**
 * 사용자 정보 수정
 * @param userInfo
 * @returns {Promise<null>}
 */
export async function updateUser(userInfo) {
  let returnVal = null;
  await AdminAxios('PUT', USER_MANAGE_URL, userInfo)
    .then((response) => {
      const { statusCode } = response;
      if(statusCode ===200){
        returnVal = true
      }else{
        returnVal = false
      }
    }).catch((e) => returnVal = false)
  return returnVal;
};

/**
 * 최신 약관 정보 가져오기 api
 * @returns {Promise<null>}
 */
export async function selPolicyLatestTerms() {
  let returnVal = null;
  await AdverAxios('GET', TERMS_INFO, null)
    .then((response) => {
      const { data, statusCode } = response;
      if (statusCode === 200) {
        returnVal = data;
      } else {
        returnVal = null;
      }
      // eslint-disable-next-line no-restricted-globals
    }).catch((e) => {location.replace('/500.js')})
  return returnVal;
}

/**
 * 회원 가입 api
 * @param userInfo
 * @returns {Promise<*>}
 */
export async function signUp(userInfo) {
  let returnVal = null;
  let param = {
    ...userInfo,
    isAgreedByOperationTerms: userInfo.isAgreedByOperationTerms ? 'Y' : 'N',
  isAgreedByPrivacyTerms: userInfo.isAgreedByPrivacyTerms ? 'Y' : 'N',
  isAgreedByServiceTerms: userInfo.isAgreedByServiceTerms ? 'Y' : 'N'
}
  await AdverAxios('POST', SIGNUP_URL, param)
    .then((response) => {
      const { data, statusCode, message } = response;
      if(statusCode === 200){
        returnVal = true;
      }else{
        returnVal = false;
      }
    }).catch((e) => returnVal = false)
  return responseFormatMessage(returnVal);
}

/**
 * 아이디 중복 검사 api
 * @param userId
 * @returns {Promise<null>}
 */
export async function selValidUserId(username) {
  let returnVal = null;
  await AdverAxios('GET', VALID_USERID+SLASH+username, null)
    .then((response) => {
      const { data, statusCode, message } = response;
      if (statusCode === 200) {
        returnVal = data
      } else {
        returnVal = message
      }
    }).catch((e) => returnVal = false)
  return returnVal;
}

/**
 * 아이디 찾기 API
 * @param userId
 * @returns {Promise<null>}
 */
export async function selFindUserId(userInfo) {
  let returnVal = null;
  await AdverAxios('POST', FIND_USERID, userInfo)
    .then((response) => {
      const { data, statusCode, message } = response;
      if (statusCode === 200) {
        returnVal = data;
      } else {
        returnVal = message;
      }
    }).catch((e) => returnVal = false)
  return returnVal;
}

/**
 * 비밀번호 변경
 * @param userInfo
 * @returns {Promise<null>}
 */
export async function selChangePassword(userInfo) {
  let returnVal = null;
  await AdverAxios('POST', CHANGE_PASSWORD, userInfo)
    .then((response) => {
      const { data, statusCode } = response;
      if (statusCode === 200) {
        returnVal = true
      } else {
        returnVal = false
      }
    }).catch((e) => returnVal = false)
  return returnVal;
}

/**
 * 광고주 검색 api
 * @param keyword
 * @returns {Promise<null>}
 */
export async function selKeywordUser(keyword) {
  let returnVal = null;
  await AdminAxios('GET', USER_KEYWORD_SEARCH + '?keyword=' + keyword, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data
    }else{
      returnVal = []
    }
  }).catch((e) => returnVal = false)
  return returnVal;
}
/**
 * 캠페인 검색 api
 * @param keyword
 * @returns {Promise<null>}
 */
export async function selKeywordAdminCampaign(id, keyword) {
  let returnVal = null;
  await AdminAxios('GET', CAMPAIGN_KEYWORD_SEARCH.replaceAll('{id}', id) + '?keyword=' + keyword, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data
    }else{
      returnVal = []
    }
  }).catch((e) => returnVal = false)
  return returnVal;
}
/**
 * 지면 검색 api
 * @param keyword
 * @returns {Promise<null>}
 */
export async function selInventoryByAdminCampaign(id) {
  let returnVal = null;
  await AdminAxios('GET', INVENTORY_KEYWORD_SEARCH.replaceAll('{id}', id), null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data
    }else{
      returnVal = []
    }
  }).catch((e) => returnVal = false)
  return returnVal;
}

/**
 * 캠페인 검색 api
 * @param keyword
 * @returns {Promise<null>}
 */
export async function selKeywordCampaign(id, keyword) {
  let returnVal = null;
  await AdverAxios('GET', USER_CAMPAIGN_KEYWORD_SEARCH.replaceAll('{id}', id) + '?keyword=' + keyword, null)
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data
    }else{
      returnVal = []
    }
  }).catch((e) => returnVal = false)
  return returnVal;
}
/**
 * 사용자 정보 가져오기 by userId
 * @param userId
 * @returns {Promise<null>}
 */
export async function selUserByUserId(username) {
  let returnVal = null;
  await AdverAxios('GET', BY_USER_INFO + SLASH + username, null)
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode ===200){
        returnVal = data
      } else {
        returnVal = null
      }
    }).catch((e) => returnVal = false)
  return returnVal;
}

/**
 * 통장 사본 및 사업자 등록증 등록
 * @param resourceType
 * @returns {Promise<false>}
 */
export async function accountFileUpload(data,resourceType) {
  let returnVal = null;
  await AxiosImageAdver('POST', UPLOAD_URL + resourceType, data).then(response => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      } else {
        returnVal = false;
      }
    })
    .catch((e) => returnVal = false)
  return returnVal;
}

export async function selUserMyPageInfo(id) {
  let returnVal = null;
  await AdverAxios('GET', MY_PAGE_INFO +SLASH + id)
    .then((response) => {
      const { data, statusCode } = response;
      if (statusCode === 200) {
        returnVal = data
      } else {
        returnVal = null
      }
    }).catch((e) => returnVal = false)
  return returnVal;
};

export async function updateMyPageUser(userInfo) {
  let returnVal = null;
  await AdverAxios('PUT', ACTION_URL, userInfo)
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode ===200){
        returnVal = true
      }else{
        returnVal = false
      }
    }).catch((e) => returnVal = false)
  return returnVal;
};

/**
 * 통장 사본 및 사업자 등록증 조회
 * @param filePath
 * @returns {Promise<false>}
 */




